import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  ENTERPRISE_ADMIN_ACCESS_OPTIONS,
  ENTERPRISE_MONTHLY_AD_SPEND_RANGE_OPTIONS,
  ENTERPRISE_PHASE1_PAID_CHANNELS_OPTIONS,
} from "../../../../utils/constants";
import {
  ENTERPRISE_INTAKE_FIELD_ADMIN_ACCESS_PHASE1,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_AD_SPEND_RANGE,
  ENTERPRISE_INTAKE_FIELD_PHASE1_PAID_CHANNELS,
  ENTERPRISE_INTAKE_HINT_MONTHLY_AD_SPEND_RANGE,
  ENTERPRISE_INTAKE_MODULE2_FIELD_AD_ACCOUNTS_OR_ADVERTISERS_COUNT,
  ENTERPRISE_INTAKE_MODULE2_FIELD_CAMPAIGN_VOLUME_VARIATION,
  ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_CAMPAIGNS_COUNT,
  ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_OPTIMIZATIONS_COUNT,
  ENTERPRISE_INTAKE_MODULE2_FIELD_PEAK_MONTH_CAMPAIGNS_COUNT,
  ENTERPRISE_INTAKE_MODULE2_HINT_MONTHLY_CAMPAIGNS,
  ENTERPRISE_INTAKE_MODULE2_HINT_MONTHLY_OPTIMIZATIONS,
  ENTERPRISE_INTAKE_MODULE2_INTRO,
} from "../../../../i18n/keysTranslations";
import ReadOnlySectionGrid from "../../../PreActivation/components/ReadOnlySectionGrid";
import CheckboxGroupWithOtherField from "../shared/CheckboxGroupWithOtherField";
import ModuleSectionIntro from "../shared/ModuleSectionIntro";
import NumericFieldBlock from "../shared/NumericFieldBlock";
import RadioWithOtherField from "../shared/RadioWithOtherField";
import VolumeVariationField from "../shared/VolumeVariationField";
import { mapTranslatedOptions } from "../shared/mapTranslatedOptions";

const Module2PaidMediaLaunchSection = ({ control, errors, readOnly }) => {
  const { t } = useTranslation();

  const paidChannelsOptions = useMemo(
    () =>
      mapTranslatedOptions({
        options: ENTERPRISE_PHASE1_PAID_CHANNELS_OPTIONS,
        t,
      }),
    [t]
  );

  const adSpendOptions = useMemo(
    () =>
      mapTranslatedOptions({
        options: ENTERPRISE_MONTHLY_AD_SPEND_RANGE_OPTIONS,
        t,
      }),
    [t]
  );

  const adminAccessOptions = useMemo(
    () => mapTranslatedOptions({ options: ENTERPRISE_ADMIN_ACCESS_OPTIONS, t }),
    [t]
  );

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      {!readOnly ? (
        <ModuleSectionIntro introKey={ENTERPRISE_INTAKE_MODULE2_INTRO} />
      ) : null}

      <NumericFieldBlock
        name="module2AdAccountsOrAdvertisersCount"
        labelKey={
          ENTERPRISE_INTAKE_MODULE2_FIELD_AD_ACCOUNTS_OR_ADVERTISERS_COUNT
        }
        required
        control={control}
        errors={errors}
        readOnly={readOnly}
        t={t}
      />

      <CheckboxGroupWithOtherField
        name="phase1PaidChannels"
        otherName="phase1PaidChannelsOther"
        labelKey={ENTERPRISE_INTAKE_FIELD_PHASE1_PAID_CHANNELS}
        required
        options={paidChannelsOptions}
        control={control}
        errors={errors}
        readOnly={readOnly}
      />

      <NumericFieldBlock
        name="module2MonthlyCampaignsCount"
        labelKey={ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_CAMPAIGNS_COUNT}
        hintKey={ENTERPRISE_INTAKE_MODULE2_HINT_MONTHLY_CAMPAIGNS}
        required
        control={control}
        errors={errors}
        readOnly={readOnly}
        t={t}
      />

      <NumericFieldBlock
        name="module2MonthlyOptimizationsCount"
        labelKey={ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_OPTIMIZATIONS_COUNT}
        hintKey={ENTERPRISE_INTAKE_MODULE2_HINT_MONTHLY_OPTIMIZATIONS}
        required
        control={control}
        errors={errors}
        readOnly={readOnly}
        t={t}
      />

      <RadioWithOtherField
        name="monthlyAdSpendRange"
        otherName="monthlyAdSpendRangeOther"
        labelKey={ENTERPRISE_INTAKE_FIELD_MONTHLY_AD_SPEND_RANGE}
        hintKey={ENTERPRISE_INTAKE_HINT_MONTHLY_AD_SPEND_RANGE}
        required
        options={adSpendOptions}
        control={control}
        errors={errors}
        readOnly={readOnly}
      />

      <RadioWithOtherField
        name="hasAdminAccessPhase1"
        otherName="hasAdminAccessPhase1Other"
        labelKey={ENTERPRISE_INTAKE_FIELD_ADMIN_ACCESS_PHASE1}
        required
        options={adminAccessOptions}
        control={control}
        errors={errors}
        readOnly={readOnly}
      />

      <VolumeVariationField
        variationName="module2CampaignVolumeVariation"
        peakName="module2PeakMonthCampaignsCount"
        labelKey={ENTERPRISE_INTAKE_MODULE2_FIELD_CAMPAIGN_VOLUME_VARIATION}
        peakLabelKey={
          ENTERPRISE_INTAKE_MODULE2_FIELD_PEAK_MONTH_CAMPAIGNS_COUNT
        }
        control={control}
        errors={errors}
        readOnly={readOnly}
      />
    </ReadOnlySectionGrid>
  );
};

export default Module2PaidMediaLaunchSection;
